//Creates new Stopper and assigns ID and type
export const createStopper = (data) => {
    //data = {id, type}
    return { type: "CREATE_STOPPER", payload: data}
}


export const setStopperHeld = (data) => {
    //data = {id, inScene}
    return { type: "SET_STOPPER_HELD", payload: data}
}

//Set whether the pipette controls are displayed or not
export const setStopperControlVisibility = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_STOPPER_CONTROLS_VISIBLE", payload: data}
  }

  export const setStoppersInScene = data => {
    //data = {type, inScene}
    return { type: "SET_STOPPERS_IN_SCENE", payload: data };
  };